export const sharedInvoiceDesignDe = {
  "Invoice design": "Design",
  "Invoice design display name": "Anzeigename",
  "Invoice design logo": "Logo",
  "Invoice design drop logo": "Logo hierher ziehen oder anklicken",
  "Invoice design remove logo": "Logo entfernen",
  "Invoice design enlarge logo": "Logo vergrößern",
  "Invoice design select another logo": "anderes Logo wählen",
  "Invoice design accent color": "Akzentfarbe",
  "Invoice design invalid accent color": "Bitte eine Farbe im Format #RRGGBB eingeben.",
  "Invoice design color none": "keine Farbe",
  "Invoice design color selected": "gewählte Farbe",
  "Invoice design color remove": "Farbe entfernen",
  "Invoice design color hex": "Hex-Wert",
  "Invoice design footer extra": "Fußzeile",
  "Invoice design footer extra hint": "Optionaler Zusatz zur Fußzeile, zum Beispiel Bankverbindung. Mehrere Zeilen sind möglich.",
  "Invoice design preview": "Vorschau",
  "Invoice design preview actions": "Vorschauaktionen",
  "Invoice design download PDF": "Vorschau herunterladen",
  "Invoice design save": "speichern",
  "Invoice design preview title": "Rechnungsvorschau",
  "Invoice design preview zoom out": "Vorschau verkleinern",
  "Invoice design preview zoom in": "Vorschau vergrößern",
  "Invoice design preview loading": "Die Rechnungsvorschau wird geladen …",
  "Invoice design preview failed": "Die Rechnungsvorschau konnte nicht angezeigt werden.",
  "Invoice design logo alt": "Rechnungslogo",
} as const;

export const sharedInvoiceDesignEn = {
  "Invoice design": "Design",
  "Invoice design display name": "Display name",
  "Invoice design logo": "Logo",
  "Invoice design drop logo": "Drop a logo here or click to upload",
  "Invoice design remove logo": "Remove logo",
  "Invoice design enlarge logo": "Enlarge logo",
  "Invoice design select another logo": "Select another logo",
  "Invoice design accent color": "Accent color",
  "Invoice design invalid accent color": "Enter a color in #RRGGBB format.",
  "Invoice design color none": "no color",
  "Invoice design color selected": "selected color",
  "Invoice design color remove": "remove color",
  "Invoice design color hex": "hex value",
  "Invoice design footer extra": "Footer",
  "Invoice design footer extra hint": "Optional extra footer text, for example bank details. Multiple lines are allowed.",
  "Invoice design preview": "Preview",
  "Invoice design preview actions": "Preview actions",
  "Invoice design download PDF": "Download PDF",
  "Invoice design save": "Save",
  "Invoice design preview title": "Invoice preview",
  "Invoice design preview zoom out": "zoom out preview",
  "Invoice design preview zoom in": "zoom in preview",
  "Invoice design preview loading": "Loading invoice preview …",
  "Invoice design preview failed": "The invoice preview could not be displayed.",
  "Invoice design logo alt": "Invoice logo",
} as const;

export const sharedInvoiceDesignRu = {
  "Invoice design": "Дизайн",
  "Invoice design display name": "Отображаемое имя",
  "Invoice design logo": "Логотип",
  "Invoice design drop logo": "Перетащите логотип сюда или нажмите",
  "Invoice design remove logo": "Удалить логотип",
  "Invoice design enlarge logo": "Увеличить логотип",
  "Invoice design select another logo": "Выбрать другой логотип",
  "Invoice design accent color": "Акцентный цвет",
  "Invoice design invalid accent color": "Введите цвет в формате #RRGGBB.",
  "Invoice design color none": "без цвета",
  "Invoice design color selected": "выбранный цвет",
  "Invoice design color remove": "удалить цвет",
  "Invoice design color hex": "HEX-значение",
  "Invoice design footer extra": "Нижний колонтитул",
  "Invoice design footer extra hint": "Необязательное дополнение к колонтитулу, например банковские реквизиты. Можно несколько строк.",
  "Invoice design preview": "Предпросмотр",
  "Invoice design preview actions": "Действия предпросмотра",
  "Invoice design download PDF": "Скачать PDF",
  "Invoice design save": "Сохранить",
  "Invoice design preview title": "Предпросмотр счета",
  "Invoice design preview zoom out": "уменьшить предпросмотр",
  "Invoice design preview zoom in": "увеличить предпросмотр",
  "Invoice design preview loading": "Загрузка предпросмотра счета …",
  "Invoice design preview failed": "Не удалось отобразить предпросмотр счета.",
  "Invoice design logo alt": "Логотип счета",
} as const;

export const sharedInvoiceDesignUk = {
  "Invoice design": "Дизайн",
  "Invoice design display name": "Відображувана назва",
  "Invoice design logo": "Логотип",
  "Invoice design drop logo": "Перетягніть логотип сюди або натисніть",
  "Invoice design remove logo": "Видалити логотип",
  "Invoice design enlarge logo": "Збільшити логотип",
  "Invoice design select another logo": "Вибрати інший логотип",
  "Invoice design accent color": "Акцентний колір",
  "Invoice design invalid accent color": "Введіть колір у форматі #RRGGBB.",
  "Invoice design color none": "без кольору",
  "Invoice design color selected": "вибраний колір",
  "Invoice design color remove": "видалити колір",
  "Invoice design color hex": "HEX-значення",
  "Invoice design footer extra": "Нижній колонтитул",
  "Invoice design footer extra hint": "Необов’язковий додаток до колонтитула, наприклад банківські реквізити. Можна кілька рядків.",
  "Invoice design preview": "Попередній перегляд",
  "Invoice design preview actions": "Дії попереднього перегляду",
  "Invoice design download PDF": "Завантажити PDF",
  "Invoice design save": "Зберегти",
  "Invoice design preview title": "Попередній перегляд рахунку",
  "Invoice design preview zoom out": "зменшити попередній перегляд",
  "Invoice design preview zoom in": "збільшити попередній перегляд",
  "Invoice design preview loading": "Завантаження попереднього перегляду рахунку …",
  "Invoice design preview failed": "Не вдалося відобразити попередній перегляд рахунку.",
  "Invoice design logo alt": "Логотип рахунку",
} as const;

export const sharedInvoiceDesignIt = {
  "Invoice design": "Design",
  "Invoice design display name": "Nome visualizzato",
  "Invoice design logo": "Logo",
  "Invoice design drop logo": "Trascina qui il logo oppure fai clic",
  "Invoice design remove logo": "Rimuovi logo",
  "Invoice design enlarge logo": "Ingrandisci logo",
  "Invoice design select another logo": "Seleziona un altro logo",
  "Invoice design accent color": "Colore principale",
  "Invoice design invalid accent color": "Inserisci un colore nel formato #RRGGBB.",
  "Invoice design color none": "nessun colore",
  "Invoice design color selected": "colore selezionato",
  "Invoice design color remove": "rimuovi colore",
  "Invoice design color hex": "valore esadecimale",
  "Invoice design footer extra": "Piè di pagina",
  "Invoice design footer extra hint": "Testo facoltativo nel piè di pagina, ad esempio coordinate bancarie. Sono ammesse più righe.",
  "Invoice design preview": "Anteprima",
  "Invoice design preview actions": "Azioni anteprima",
  "Invoice design download PDF": "Scarica PDF",
  "Invoice design save": "Salva",
  "Invoice design preview title": "Anteprima fattura",
  "Invoice design preview zoom out": "rimpicciolire anteprima",
  "Invoice design preview zoom in": "ingrandire anteprima",
  "Invoice design preview loading": "Caricamento dell’anteprima fattura …",
  "Invoice design preview failed": "Impossibile visualizzare l’anteprima fattura.",
  "Invoice design logo alt": "Logo fattura",
} as const;

export type SharedInvoiceDesignTranslationKey = keyof typeof sharedInvoiceDesignEn;
